import { useFormattedYears } from '../../../../../../hooks/formatters';
import { WIDGET_COLORS } from '../../consts';
import {
  ExperienceValue,
  PanelRow,
  RoleName,
  RoleCircle,
  Panel,
} from './industry-list.styled';

type IndustryListProps = {
  items: ExperienceByIndustryChart[],
};

const MAX_ITEMS_TO_SHOW = 5;

export const IndustryList = ({
  items,
}:IndustryListProps):JSX.Element => {
  const getFormattedYears = useFormattedYears();

  return (
    <Panel>
      {
        items.slice(0, MAX_ITEMS_TO_SHOW).map((item: ExperienceByIndustryChart, index: number) => {
          return (
            <PanelRow key={ `${item.industry}${item.tenureInMonths}` }>
              <RoleCircle
                size={ 8 }
                color={ WIDGET_COLORS[index % WIDGET_COLORS.length] }
              />
              <RoleName>{item.industry}</RoleName>
              <ExperienceValue>{getFormattedYears(item.tenureInMonths)}
              </ExperienceValue>
            </PanelRow>
          );
        })
      }
    </Panel>
  );
};
